import React from "react";
import useGitHubSkills from "../../hooks/useGitHubSkills";
import SkillGraph from "./SkillGraph";
import SkillLegend from "./SkillLegend";
import "./Skills.css";

const Skills = () => {
  const { graphData, loading, error } = useGitHubSkills();

  return (
    <div className="skills-wrapper">
      <h2 className="skills-title">Skills</h2>

      {loading && (
        <div className="skills-skeleton">
          <div className="skeleton-pulse" />
        </div>
      )}

      {error && !loading && (
        <div className="skills-error">
          Unable to load skills from GitHub. {error}
        </div>
      )}

      {graphData && !loading && (
        <>
          <SkillGraph graphData={graphData} />
          <SkillLegend />
          <p className="skills-source-note">
            Skills auto-detected from public GitHub repositories — languages by lines of code, frameworks by repo topics.
          </p>
        </>
      )}
    </div>
  );
};

export default Skills;
